import React from 'react';
import '../../css/footer.css';
import { motion } from 'framer-motion';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  // FaTelegram,
} from 'react-icons/fa'; // Import icons

const Footer = () => {
  const footerVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, ease: 'easeInOut' },
  };

  return (
    <motion.footer
      variants={footerVariants}
      initial="initial"
      animate="animate"
      className="footer"
    >
      <div className="footer-content">
        <div className="footer-about">
          <h3>About Us</h3>
          <p>
            Driven by passion and innovation, we craft solutions that empower
            businesses and individuals to thrive and reach their full potential.
          </p>
        </div>
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/service">Services</a>
            </li>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>
        <div className="footer-contact">
          <h3>Feel Free to Reach Out </h3>
          <p>
            Email:
            <a
              href="mailto:matiraminfotech@gmail.com"
              style={{
                color: '#fff',
                textDecoration: 'none',
                fontWeight: 'none',
              }}
              onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
              onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
            >
              matiraminfotech@gmail.com
            </a>
          </p>

          <p>Phone: +91-7814-088-164</p>
          <p>Address: sector-25 Panchkula, Haryana</p>
        </div>
        <div className="footer-social">
          <h3>Follow Us</h3>
          <ul className="social-icons">
            <li>
              <a
                href="https://www.facebook.com/share/1aN7GuYM3m/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
            </li>

            <li>
              <a
                href="https://x.com/Matiraminfotech?s=08"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/matiraminfotech?igsh=ZDhyYjNtbGFyb3Rh"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
            </li>
            <li>
              <a
                href="http://www.linkedin.com/in/matiram-infotech-06576a354"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
            </li>
            {/* <li>
              <a
                href="https://t.me/Sandeep2390"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTelegram />
              </a>
            </li> */}
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} MatiRam InfoTech. All rights
          reserved.
        </p>
      </div>
    </motion.footer>
  );
};

export default Footer;
